import axiosInstance from "service/axiosInstance";
import { CrmComment, CrmCommentRepliesPage, CrmParentType, CrmEntityType } from "types/crm/comments";

const commentsPath = (
  parentType: CrmParentType, 
  parentUuid: string,
  entityType: CrmEntityType,
  entityUuid: string,
) => `/crm/${parentType}/${parentUuid}/${entityType}/${entityUuid}/comments`;

export const crmCommentQueryKeys = {
  all: ["crm-comments"] as const,
  base: (parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string) =>
    [...crmCommentQueryKeys.all, parentType, parentUuid, entityType, entityUuid] as const,
  replies: (
    parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string,
    commentUuid: string, page: number,
  ) => [...crmCommentQueryKeys.base(parentType, parentUuid, entityType, entityUuid), "replies", commentUuid, page] as const,
};

export const crmCommentApi = {
  getComments: async (
    parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string,
    page = 0, size = 20,
  ): Promise<CrmCommentRepliesPage> => {
    const { data } = await axiosInstance.get(commentsPath(parentType, parentUuid, entityType, entityUuid), {
      params: { page, size },
    });
    return data.data;
  },

  addComment: async (
    parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string,
    commentText: string, parentCommentUuid?: string | null,
  ): Promise<CrmComment> => {
    const { data } = await axiosInstance.post(commentsPath(parentType, parentUuid, entityType, entityUuid), {
      commentText,
      parentCommentUuid: parentCommentUuid ?? null,
    });
    return data.data;
  },

  updateComment: async (
    parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string,
    commentUuid: string, commentText: string, parentCommentUuid?: string | null,
  ): Promise<CrmComment> => {
    const { data } = await axiosInstance.put(
      `${commentsPath(parentType, parentUuid, entityType, entityUuid)}/${commentUuid}`,
      { commentText, parentCommentUuid: parentCommentUuid ?? null },
    );
    return data.data;
  },

  deleteComment: async (
    parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string,
    commentUuid: string,
  ): Promise<void> => {
    await axiosInstance.delete(`${commentsPath(parentType, parentUuid, entityType, entityUuid)}/${commentUuid}`);
  },

  getCommentReplies: async (
    parentType: CrmParentType, parentUuid: string, entityType: CrmEntityType, entityUuid: string,
    commentUuid: string, page = 0, size = 20,
  ): Promise<CrmCommentRepliesPage> => {
    const { data } = await axiosInstance.get(
      `${commentsPath(parentType, parentUuid, entityType, entityUuid)}/${commentUuid}/replies`,
      { params: { page, size } },
    );
    return data.data;
  },
};